import { cpf, cnpj } from "cpf-cnpj-validator";

export function formaterDocument(document: string) {
  let formated = document;

  try {
    if (document.length === 11) {
      formated = cpf.format(document);
    } else {
      formated = cnpj.format(document);
    }
  } catch (e) {
    formated = document;
  }

  return formated;
}
